import React from "react";

const ReferralSettings = React.lazy(() => import('src/pages/referral_settings/ReferralSettings'));

const routes = [
    { path: '/dashboard/referral-settings', name: 'Referral Settings', element: ReferralSettings },
];

export default routes;
